export enum FeatureFlags {
  DASHBOARD = 'dashboard',
  BUSINESS_UNITS_MANAGEMENT = 'business_units_management',
  BUSINESS_UNITS_DELETE = 'business_units_delete',
  // MARK: WhatsNew
  WHATS_NEW_PAGE = 'whats_new_page',
  WHATS_NEW_CREATE = 'whats_new_create',
  WHATS_NEW_EDIT = 'whats_new_edit',
  WHATS_NEW_SUBMIT = 'whats_new_submit',
  WHATS_NEW_APPROVE = 'whats_new_approve',
  WHATS_NEW_DELETE = 'whats_new_delete',
  WHATS_NEW_APPROVE_OWN = 'whats_new_approve_own',
  WHATS_NEW_RESET_VIEWER = 'whats_new_reset_viewer',
  // MARK: Pages
  PAGES_PAGE = 'pages_page',
  PAGES_CREATE = 'pages_create',
  PAGES_EDIT = 'pages_edit',
  PAGES_DELETE = 'pages_delete',
  // MARK: Tours
  TOURS_PAGE = 'tours_page',
  TOURS_CREATE = 'tours_create',
  TOURS_EDIT = 'tours_edit',
  TOURS_SUBMIT = 'tours_submit',
  TOURS_APPROVE = 'tours_approve',
  TOURS_DELETE = 'tours_delete',
  TOURS_RESET_VIEWER = 'tours_reset_viewer',
  // MARK: Opt-in features
  OPT_IN_FEATURES_PAGE = 'opt_in_features_page',
  OPT_IN_FEATURES_CREATE = 'opt_in_features_create',
  OPT_IN_FEATURES_EDIT = 'opt_in_features_edit',
  OPT_IN_FEATURES_DELETE = 'opt_in_features_delete',
  OPT_IN_PURGE = 'opt_in_purge',
  // MARK: Surveys
  SURVEYS_PAGE = 'surveys_page',
  SURVEYS_CREATE = 'surveys_create',
  SURVEYS_EDIT = 'surveys_edit',
  SURVEYS_DELETE = 'surveys_delete',
  SURVEYS_SUBMIT = 'surveys_submit',
  SURVEYS_APPROVE = 'surveys_approve',
  SURVEYS_RESULTS = 'surveys_results',
  SURVEYS_PURGE = 'surveys_purge',
  // MARK: Employee Signatures
  EMPLOYEE_SIGNATURE_PAGE = 'employee_signature_page',
  EMPLOYEE_SIGNATURE_DOWNLOAD = 'employee_signature_download',
  EMPLOYEE_SIGNATURE_SEND_EMAIL = 'employee_signature_send_email',
  EMPLOYEE_SIGNATURE_CREATE = 'employee_signature_page_create',
  // MARK: Settings - User Management
  SETTINGS_USERS_PAGE = 'settings_users_page',
  SETTINGS_USERS_CREATE = 'settings_users_create',
  SETTINGS_USERS_EDIT = 'settings_users_edit',
  SETTINGS_USERS_DELETE = 'settings_users_delete',
  SETTINGS_USERS_MANAGE_PERMISSIONS = 'settings_users_manage_permissions',
  // MARK: Platform Users
  PLATFORM_USERS_PREFERENCES_PAGE = 'platform_users_preferences_page',
}
